// components/CommonSearch.js
import React from 'react';
import { Input, Icon } from 'antd';

const CommonSearch = ({ value, onChange, onSearch, onClear, placeholder = 'Search ...' }) => {
  return (
    <Input
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      onPressEnter={() => onSearch?.(value)}
      suffix={
        value ? (
          <Icon
            type="close-circle"
            onClick={onClear}
            style={{ color: 'rgba(0,0,0,.45)', cursor: 'pointer' }}
          />
        ) : (
          <Icon type="search" style={{ color: 'rgba(0,0,0,.45)' }} />
        )
      }
    />
  );
};

export default CommonSearch;
